import React from "react";
import { motion } from "framer-motion";

function Icon() {
  const svgVariant = {
    hidden: { rotate: "0deg" },
    visible: { rotate: "0deg", transition: { duration: 1 } },
  };

  const pathVariant = {
    hidden: { pathLength: 0, fillOpacity: 0 },
    visible: {
      pathLength: 1,
      fillOpacity: 1,
      transition: { duration: 1, ease: "easeInOut" },
    },
  };

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 47.625 39.688"
      id="svg1468"
      width="80"
      height="50"
      variants={svgVariant}
      initial="hidden"
      animate="visible"
      style={{ marginLeft: "-10px" }}
    >
      <g>
        <g
          id="layer1"
          fill="#006ede"
          fillOpacity="1"
          fillwidth="1"
          stroke="#006ede"
          strokeOpacity="1"
          strokeWidth="1"
          fontFamily="Beautiful People Personal Use"
          fontSize="32.111"
          fontStretch="normal"
          fontStyle="normal"
          fontVariant="normal"
          fontWeight="normal"
        >
          <motion.path
            d="M.616 13.988q-.185-3.05 1.068-5.486Q2.936 6.04 5.22 4.332q2.321-1.735 5.49-2.659Q13.878.75 17.525.778q3.426.028 5.968.923 2.542.896 4.2 2.211 1.657 1.316 2.504 2.883.848 1.54.921 2.911.111 2.491-.994 4.842-1.069 2.351-3.132 4.366-2.063 2.015-4.936 3.639-2.837 1.595-6.263 2.575 1.437 1.287 3.5 2.939 2.1 1.623 4.642 3.19 2.542 1.54 5.378 2.827 2.874 1.288 5.858 1.847 2.984.588 5.968.252 3.02-.336 5.857-2.015-.147.924-.368 1.68-.184.643-.516 1.259-.295.616-.737.756-3.72 1.26-7.183 1.203-3.426-.028-6.558-.98-3.094-.923-5.82-2.518-2.69-1.568-4.937-3.36-2.247-1.79-4.015-3.554-1.732-1.763-2.91-3.05-1.622.391-3.242.587l-.369 8.425q0 .196-.368.252-.332.056-.737.028-.405-.028-.737-.168-.331-.112-.331-.28-.037-1.036-.037-2.323-.037-1.092-.037-2.547 0-1.483-.037-3.163-.774.056-1.547.084-.774 0-1.547-.056-.553-.028-.81-.224-.222-.196-.222-.42.037-.223.295-.42.258-.195.737-.223.81-.028 1.547-.084.773-.056 1.51-.112 0-1.176-.037-2.24-.036-1.09-.036-2.266-1.253-.196-2.506-.616-1.252-.448-2.32-1.232-1.032-.783-1.732-1.903-.663-1.147-.773-2.715zm7.036-4.842q.074 0 .737-.308.663-.336 1.363-.587.736-.28 1.29-.308.552-.028.441.56l-.405 9.488q1.29-.28 2.652-1.008 1.4-.728 2.8-2.183.258-.252.479.084.221.336.368.896.148.56.148 1.147.037.588-.11.84-.259.504-.885.98-.59.447-1.473.839-.848.364-1.916.644-1.032.252-2.174.336l-.184 4.03q7.368-1.204 11.42-4.842 4.09-3.639 4.31-9.656.037-.896-.515-2.1-.553-1.23-1.658-2.35t-2.763-1.904q-1.62-.783-3.72-.811-1.732-.028-3.537.196t-3.537.727q-1.694.476-3.242 1.26Q6.031 5.9 4.89 6.99 3.747 8.055 3.047 9.454q-.7 1.372-.737 3.079-.074 2.407 1.474 3.89 1.584 1.484 4.126 1.764-.037-1.792-.074-3.443t-.074-2.883q-.036-1.231-.073-1.96 0-.755-.037-.755z"
            style={{ lineHeight: "1.25" }}
            variants={pathVariant}
          ></motion.path>
          <motion.path
            d="M37.97 4.36q-.036-.168.516-.252.59-.084 1.29-.028.7.028 1.252.28.553.252.516.756 0 .084-.074 1.203-.073 1.12-.147 2.911t-.184 4.059q-.074 2.239-.148 4.59-.073 2.323-.147 4.562-.074 2.239-.074 4.002 0 1.736.037 2.8.037 1.063.147 1.063.406.028.81-.42.443-.448.848-1.12.405-.671.774-1.455.368-.784.626-1.456.295-.671.442-1.12.184-.447.221-.447.037 0 .184.028.185 0 .369.028.184 0 .331.056.148.028.148.112 0 .056-.221.644-.184.588-.553 1.455-.331.84-.884 1.847-.516.98-1.179 1.82-.663.811-1.473 1.371-.81.532-1.695.504-.958 0-1.437-.532-.479-.56-.663-1.147-.516.671-1.142 1.035-.626.336-1.216.504-.589.14-1.068.168-.479 0-.7-.028-.516-.028-1.363-.252-.847-.252-1.658-.98-.81-.755-1.4-2.183-.552-1.427-.515-3.862.036-2.1.479-3.527.478-1.455 1.142-2.379.663-.923 1.473-1.427.81-.532 1.547-.756.774-.224 1.327-.252.589-.056.847-.056.92.028 1.51.476.627.448.995.952.074-2.24.11-4.45.074-2.212.111-4.059.037-1.875 0-3.19-.037-1.344-.11-1.848zm-.478 23.875q.036-1.316.11-3.583.11-2.267.221-5.094-.074-.336-.331-.672-.221-.364-.516-.615-.295-.28-.663-.448-.332-.196-.663-.196-.7 0-1.253.42-.516.391-.92 1.063-.406.644-.7 1.456-.259.783-.443 1.567-.147.784-.258 1.455-.073.672-.11 1.064-.074.56-.037 1.595.074 1.036.331 2.071.258 1.036.81 1.792.553.727 1.548.7.7 0 1.179-.252.479-.28.774-.644.331-.392.515-.812.221-.448.369-.84z"
            style={{ lineHeight: "1.25" }}
            variants={pathVariant}
          ></motion.path>
        </g>
      </g>
    </motion.svg>
  );
}

export default Icon;
